import { useMemo } from 'react';

function useShippingSpeedFieldName(name = null) {
  return useMemo(() => (name || 'shipModeId'), [name]);
}

export default useShippingSpeedFieldName;
